import React from "react";

import Button from "@mui/material/Button";
import { styled } from "@mui/material/styles";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import { DialogContentText } from "@mui/material";

import { SharedEpisode } from "../../services/shared-episodes.service";

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  "& .MuiDialogContent-root": {
    padding: theme.spacing(4),
  },
  "& .MuiDialogActions-root": {
    padding: theme.spacing(1),
  },
}));

interface Props {
  sharedEpisode: SharedEpisode;
  handleClose: () => void;
  handleConfirm: () => void;
  open: boolean;
}

export default function ConfirmRevokeAccessToSharedEpisodeDialog({
  sharedEpisode,
  handleClose,
  handleConfirm,
  open,
}: Props) {
  return (
    <BootstrapDialog
      onClose={handleClose}
      aria-labelledby="customized-dialog-title"
      open={open}
      fullWidth
    >
      <DialogTitle>Are you sure you want to revoke access?</DialogTitle>
      <DialogContent>
        <DialogContentText id="alert-dialog-slide-description">
          This action cannot be undone and the user {sharedEpisode.shared_with}{" "}
          won't be able to access this episode anymore.
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose}>Close</Button>
        <Button
          sx={{
            backgroundColor: "#FF0000",
            color: "#FFFFFF",
            "&:hover": {
              backgroundColor: "#FF0000",
            },
          }}
          onClick={handleConfirm}
        >
          Delete
        </Button>
      </DialogActions>
    </BootstrapDialog>
  );
}
